// extracted by mini-css-extract-plugin
module.exports = {"container":"Popup__container__10R4g","background":"Popup__background__20PTq layout__absolute-full__3uiy6","text":"Popup__text__oWe7U"};